import type { FC } from "react";

import Header from "../common/Header";
import Footer from "../common/Footer";

interface Props {
  className?: string;
  children: React.ReactNode;
}

const ShareLayout: FC<Props> = ({ children, className = "" }) => {
  return (
    <div className={"w-full md:h-screen bg-brand-white2" + className}>
      <Header hideLink />
      <main className="md:h-[calc(100vh-48px-33px)] max-w-mainContainer mx-auto ">{children}</main>
      <Footer />
    </div>
  );
};

export default ShareLayout;
